function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

function text(value) {
  return String(value ?? '').trim();
}

function resolveQuestionById(patchQuestionNode = {}) {
  return new Map(
    resolveArray(resolveObject(patchQuestionNode).questions)
      .map((question) => resolveObject(question))
      .map((question) => [text(question.question_id), question])
      .filter(([questionId]) => Boolean(questionId)),
  );
}

function resolveOptionText(question = {}, optionId = '') {
  const normalizedOptionId = text(optionId).toUpperCase();
  const option = resolveArray(resolveObject(question).options)
    .map((item) => resolveObject(item))
    .find((item) => text(item.option_id).toUpperCase() === normalizedOptionId);
  return text(option?.text);
}

function normalizeAnswers({ patchQuestionNode = {}, answers = [] } = {}) {
  const questionById = resolveQuestionById(patchQuestionNode);
  return resolveArray(answers)
    .map((answer) => {
      const item = resolveObject(answer);
      const questionId = text(item.question_id);
      const optionId = text(item.option_id).toUpperCase();
      if (!questionId || !optionId) {
        return null;
      }
      const question = questionById.get(questionId) || {};
      return {
        question_id: questionId,
        option_id: optionId,
        question_text: text(question.question_text),
        option_text: resolveOptionText(question, optionId) || text(item.option_text),
      };
    })
    .filter(Boolean);
}

function buildAnswerContent(answers = []) {
  const parts = resolveArray(answers)
    .map((answer) => `${text(answer.question_id)}${text(answer.option_id)} ${text(answer.option_text)}`.trim())
    .filter(Boolean);
  return parts.length ? `确认应用：${parts.join('；')}` : '';
}

export function buildPatchQuestionAnswerSubmitPayload({
  patchQuestionNode = {},
  answers = [],
} = {}) {
  const node = resolveObject(patchQuestionNode);
  const normalizedAnswers = normalizeAnswers({ patchQuestionNode: node, answers });
  const content = buildAnswerContent(normalizedAnswers);
  if (!content || normalizedAnswers.length === 0) {
    return null;
  }
  return {
    content,
    streamOptions: {
      modeKey: 'requirement_intake',
      payloadExtra: {
        action_key: 'submit_patch_question_answer',
        command: 'submit_patch_question_answer',
        target_mode: 'requirement_intake',
        patch_question_answer: {
          node_id: text(node.node_id),
          answers: normalizedAnswers,
        },
        patch_question_node: node,
      },
    },
  };
}

export function buildPatchQuestionAnswerCancelPayload({
  patchQuestionNode = {},
} = {}) {
  const node = resolveObject(patchQuestionNode);
  const nodeId = text(node.node_id);
  if (!nodeId) {
    return null;
  }
  return {
    content: '取消应用本次修改',
    streamOptions: {
      modeKey: 'requirement_intake',
      payloadExtra: {
        action_key: 'cancel_patch_question_answer',
        command: 'cancel_patch_question_answer',
        target_mode: 'requirement_intake',
        patch_question_cancel: {
          node_id: nodeId,
        },
        patch_question_node: node,
      },
    },
  };
}

export default buildPatchQuestionAnswerSubmitPayload;
